<div id="Area-Chat">
  <div id="chat-wrapper" *ngIf="chatSocketService.activeChat">
    <chat-qualification-tab-actions></chat-qualification-tab-actions>
    <chat-box
      id="chat-box"
      [chat]="chatSocketService.activeChat"
      [extendedMirror]="extendMirror"
      *ngIf="!chatSocketService.activeChat.inPostTreatmentMode && chatSocketService.activeChat.chatTabState === 'chat'"
      [ngClass]="extendMirror ? 'with-extended-mirror' : 'without-extended-mirror'"
    >
    </chat-box>
    <chat-qualification
      id="chat-qualification"
      [responseId]="responseId"
      *ngIf="chatSocketService.activeChat.inPostTreatmentMode || chatSocketService.activeChat.chatTabState !== 'chat'"
    >
    </chat-qualification>
    <chat-mirror
      id="chat-mirror"
      *ngIf="!chatSocketService.activeChat.inPostTreatmentMode && chatSocketService.activeChat.chatTabState === 'chat'"
      [ngClass]="extendMirror ? 'with-extended' : 'without-extended'"
      (extended)="extendMirror = !extendMirror"
      [extendedMirror]="extendMirror"
    >
    </chat-mirror>
  </div>
  <div *ngIf="chatSocketService.websocketLost" style="text-align: center">
    <cng-page-hint loading>
      <mat-icon>exchange_off</mat-icon>
      {{ 'agent:panel.chat.server.server_lost' | translate }}
    </cng-page-hint>
  </div>

  <chat-banner *ngIf="!chatSocketService.websocketLost"></chat-banner>
</div>
